import React from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag } from '@wtag/react-comp-lib';
import getTripLabel, {
  EXCHANGE_CART,
} from '../../../../IBE/SearchDetails/flight/helpers/getTripLabel';
import './styles.scss';

const TripTitle = ({ originCode, destinationCode, isChanged, tripCount }) => (
  <div className="flight-item-trip__title d-flex align-center column-gap-8">
    <span className="flight-item-trip__title-route">
      {getTripLabel(tripCount, originCode, destinationCode, EXCHANGE_CART)}
    </span>
    <EmphasisTag
      size="tiny"
      type={isChanged ? 'danger' : 'disabled'}
      text={
        isChanged
          ? I18n.t('components.ibe.results.exchange_tag.changed')
          : I18n.t('components.ibe.results.exchange_tag.unchanged')
      }
    />
  </div>
);

TripTitle.defaultProps = {
  tripCount: null,
  isChanged: true,
};

TripTitle.propTypes = {
  originCode: PropTypes.string.isRequired,
  destinationCode: PropTypes.string.isRequired,
  isChanged: PropTypes.bool,
  tripCount: PropTypes.number,
};

export default TripTitle;
